import React, { Component } from 'react';
import PopupColorPicker from './PopupColorPicker';
import ColorInput from './ColorInput';
import { CustomPicker } from 'react-color';

class GenericColorPicker extends Component {
  render() {
    const { inputClassName, ...props } = this.props;
    return (
      <PopupColorPicker {...props} showInput={false}>
        {[
          ({ input, hex, onClick, getChangerRef, getTriggerRef }) => (
            <span ref={getTriggerRef}>
              <input type="hidden" {...input} value={hex} ref={getChangerRef} />
              <ColorInput
                inputClassName={inputClassName}
                type="text"
                value={hex}
                onChange={props.onChange}
                onClick={onClick}
              />
            </span>
          ),
        ]}
      </PopupColorPicker>
    );
  }
}

// export default GenericColorPicker;
export default CustomPicker(GenericColorPicker);

GenericColorPicker.defaultProps = {
  debounceTime: 1000,
};
